import React from 'react'
import {FieldErrors, FieldValues, UseFormRegister, Path, RegisterOptions} from 'react-hook-form'
import {getFieldError} from './getFieldError'

type Option = {label: string; value: string | number}

type SelectInputProps<T extends FieldValues> = {
  name: Path<T>
  label?: string
  register: UseFormRegister<T>
  errors?: FieldErrors<T>
  required?: boolean | string
  className?: string
  inputClassName?: string
  layout?: 'stacked' | 'half'
  placeholder?: string
  helperText?: string
  optionsList: Option[]
  onChange?: (value: string | number) => void
  options?: RegisterOptions<T, Path<T>>
}

export const SelectInput = <T extends FieldValues>({
  name,
  label,
  register,
  errors,
  required = false,
  className = '',
  inputClassName = '',
  layout = 'stacked',
  optionsList,
  onChange,
  options,
  placeholder = 'Select...',
  helperText = '',
}: SelectInputProps<T>) => {
  const error = getFieldError(errors, name)
  const wrapperClassName = layout === 'half' ? 'col-12 col-md-6 mb-0' : 'mb-3'

  return (
    <div className={`${wrapperClassName} ${className}`.trim()}>
      {label && (
        <label
          className={`form-label fw-semibold ${helperText ? 'mb-0' : 'mb-2'}`}
          htmlFor={String(name)}
        >
          {label} {required && <span className='text-danger'>*</span>}
        </label>
      )}
      {helperText && <small className='text-muted d-block mb-1 fs-6'>{helperText}</small>}

      <select
        id={String(name)}
        className={`form-select ${inputClassName} ${error ? 'is-invalid' : ''}`}
        {...register(name, {
          ...options,
          required,
          onChange: (e) => {
            if (onChange) onChange(e.target.value)
          },
        })}
      >
        {placeholder && <option value=''>{placeholder}</option>}

        {optionsList.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {error && <div className='text-danger mt-1'>{error.message}</div>}
    </div>
  )
}
